import '../../stylesheets/agreements/page';
//---------views/agreements/biz.html.slimに記載
//---------views/agreements/show_term.html.slimに記載